import React, { useState, useEffect } from "react"
import ReactDOM from "react-dom"
import "./frontend.min.css"

document.addEventListener("DOMContentLoaded", function () {
  const divsToUpdate = document.querySelectorAll(".tabmenu-update-me")

  divsToUpdate.forEach(function (div) {
    const data = JSON.parse(div.querySelector("pre").innerHTML)
    ReactDOM.render(<Tabmenu {...data} />, div)
    div.classList.remove("tabmenu-update-me")
  })

  function Tabmenu(props) {
    function changeTab(e) {
        const tabIndex = e.target.dataset.tabindex 
        e.target.parentNode.parentNode.querySelectorAll("[data-tabstatus='active']").forEach(tab => {
            tab.dataset.tabstatus = "inactive"
        })
        e.target.parentNode.parentNode.querySelectorAll('[data-tabindex="' + tabIndex + '"]').forEach(tab => {
            tab.dataset.tabstatus = "active"
        })
    }

    const tabRef = React.createRef();
    const morecontentRef = React.createRef();
    const [slider, setSlider] = useState(false)
    const [sliderMorecontent, setSliderMorecontent] = useState(false)
    const [mobileClass, setMobileClass] = useState("desktop")
    const [overflow, setOverflow] = useState("unset")

    useEffect(() => {
        MobileSlides()
    })
    window.addEventListener('resize', () => {
        MobileSlides()

    });
    
    const MobileSlides = () => {
        if (tabRef.current) {
            if (tabRef.current.scrollWidth > tabRef.current.offsetWidth) {
                setSlider(true)
                setMobileClass("mobile")
                setOverflow("scroll")
            }
            else {
                setSlider(false)
                setMobileClass("desktop")
                console.log("jorgh")
                setOverflow("unset")
            }
        }
        if (morecontentRef.current) {
            if (morecontentRef.current.scrollWidth > morecontentRef.current.offsetWidth) {
                setSliderMorecontent(true)
                setMobileClass("mobile")
            }
            else {
                setSliderMorecontent(false)
                setMobileClass("desktop")
            }
        }

    } 
    const scrollToNext = (e) => {
        let parent = e.target.closest(".tabmenu-frontend")
        let activeTab = parent.querySelector('[data-tabstatus="active"]')
        activeTab.dataset.tabstatus = "inactive"
        if (activeTab.nextElementSibling) {
            activeTab.nextElementSibling.dataset.tabstatus = "active"
        }
        else {
            parent.querySelector('[data-tabstatus="inactive"]').dataset.tabstatus = "active"
        }
        parent.querySelector(".tabHeadWrapper").scrollLeft = parent.querySelector('[data-tabstatus="active"]').offsetLeft
    }
    const scrollToPrev = (e) => {
        let parent = e.target.closest(".tabmenu-frontend")
        let activeTab = parent.querySelector('[data-tabstatus="active"]')
        activeTab.dataset.tabstatus = "inactive"
        if (activeTab.previousElementSibling) {
            activeTab.previousElementSibling.dataset.tabstatus = "active"
        }
        else {
            parent.querySelector('.tabHeadWrapper').lastElementChild.dataset.tabstatus = "active"
        }
        parent.querySelector(".tabHeadWrapper").scrollLeft = parent.querySelector('[data-tabstatus="active"]').offsetLeft
    }

    const changeOrder = (e) => {
        let parent = e.target.closest(".moreContentNav")
        let contentContainer = parent.previousElementSibling
        parent.querySelector('[data-status="active"]').dataset.status = "inactive"
        e.target.dataset.status = "active"
        contentContainer.querySelector('[data-status="active"]').dataset.status = "inactive"
        contentContainer.querySelector('[data-id="' + e.target.dataset.id +'"]').dataset.status="active"
        if (e.target.dataset.id == "more1") {
            contentContainer.dataset.slideposition = "left"
        }
        else if (e.target.dataset.id == "more2") {
            contentContainer.dataset.slideposition = "center"
        }
        else {
            contentContainer.dataset.slideposition = "right"
        }
        
    }

    return (
        <div className={"tabmenu-frontend tabmenu " + mobileClass}>
            {slider &&
                <div className="carouselNav">
                    <div onClick={(e) => scrollToPrev(e)}
                    className="carousel__prev">
                        <svg id="a" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" width="7.72" height="13.43" viewBox="0 0 7.72 13.43">
                            <path d="M1,13.43c-.26,0-.51-.1-.71-.29-.39-.39-.39-1.02,0-1.41L5.3,6.72,.29,1.71C-.1,1.32-.1,.68,.29,.29S1.32-.1,1.71,.29L7.42,6.01c.39,.39,.39,1.02,0,1.41L1.71,13.14c-.2,.2-.45,.29-.71,.29Z"/>
                        </svg>
                    </div>
                    <div onClick={(e) => scrollToNext(e)}
                    className="carousel__next">
                        <svg id="a" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" width="7.72" height="13.43" viewBox="0 0 7.72 13.43">
                            <path d="M1,13.43c-.26,0-.51-.1-.71-.29-.39-.39-.39-1.02,0-1.41L5.3,6.72,.29,1.71C-.1,1.32-.1,.68,.29,.29S1.32-.1,1.71,.29L7.42,6.01c.39,.39,.39,1.02,0,1.41L1.71,13.14c-.2,.2-.45,.29-.71,.29Z"/>
                        </svg>
                    </div>
                </div>
            }
            <div ref={tabRef} className="tabHeadWrapper" style={{overflowX: overflow}}>
                {
                props.tabHead ?
                props.tabHead.map(function (tab, index) {
                    let tabstatus = "inactive"
                    if (index == 0) {
                        tabstatus = "active"
                    }
                    return (
                        <div data-tabstatus={tabstatus} data-tabindex={index} onClick={changeTab} className="tabHead">
                            <span>{tab}</span>
                        </div>
                    )
                })
                :
                <div data-tabstatus="active" data-tabindex="0" className="tabHead">
                    Tab 1
                </div>
                }
            </div>  
            <div className="tabContentWrapper">
                {
                props.tabContent ?
                props.tabContent.map(function (tab, index) {
                    let tabstatus = "inactive"
                    if (index == 0) {
                        tabstatus = "active"
                    }
                    return (
                        <div className="tabContent" data-tabstatus={tabstatus} data-tabindex={index}>
                            <figure>
                                <img src={tab[4]} alt="" />
                            </figure>
                            <div className="mainContent">
                                <p className="headline">Headline: {tab[0]}</p>
                                <p className="content">Inhalt: {tab[1]}</p>
                                <a className="wp-block-button__link" href={tab[3]}>{tab[2]}</a>
                            </div>
                            <div ref={morecontentRef} className="moreContent">
                                <div data-id="more1" data-status="inactive" className="left">
                                    <a href={tab[6]} className="link"></a>
                                    <p className="text">{tab[5]}</p>
                                    <p className="linkText">
                                        Mehr dazu
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right-short" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
                                        </svg>
                                    </p> 
                                </div>
                                <div data-id="more2" data-status="active" className="center">
                                    <a href={tab[8]} className="link"></a>
                                    <p className="text">{tab[7]}</p>
                                    <p className="linkText">
                                        Mehr dazu
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right-short" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
                                        </svg>
                                    </p> 
                                </div>
                                <div data-id="more3" data-status="inactive" className="right">
                                    <a href={tab[10]} className="link"></a>
                                    <p className="text">{tab[9]}</p>
                                    <p className="linkText">
                                        Mehr dazu
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right-short" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
                                        </svg>
                                    </p> 
                                </div>
                            </div>
                            {sliderMorecontent &&
                                <div className="moreContentNav">
                                    <span data-id="more1" data-status="inactive" onClick={(e) => changeOrder(e)}></span>
                                    <span data-id="more2" data-status="active" onClick={(e) => changeOrder(e)}></span>
                                    <span data-id="more3" data-status="inactive" onClick={(e) => changeOrder(e)}></span>
                                </div>
                            }
                        </div>
                    )
                })
                :
                <div className="mainContent">
                    <p className="headline">Headline</p>
                    <p className="content">Inhalt</p>
                </div>
                }
            </div>
        </div>
    )
  }
})
